import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p396789013430734848',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
